module.exports = __webpack_public_path__ + "static/security5@3x-c3accdc3bf114ce5bb67a2d3468e4267.png";